import React from "react";
import SwaggerUI from "swagger-ui-react";
import { Typography } from "@mui/material";
import SwaggerWrapper from "../../components/SwaggerWrapper";

const Optimization = () => {
  return (
    <>
      <Typography variant="h4" gutterBottom>
        Routing Optimization API
      </Typography>
      <Typography variant="body2">
        The Route Optimization API can be used to solve traveling salesman or vehicle routing
        problems. Solve your first problem by following these steps. If you already have a
        GraphHopper account, start with step 2.
      </Typography>
      <SwaggerWrapper>
        <SwaggerUI
          url="/swagger/optimization.json"
          docExpansion="full"
          defaultModelExpandDepth={4}
          defaultModelsExpandDepth={4}
        />
      </SwaggerWrapper>
    </>
  );
};

export default Optimization;
